<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />

    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Filter by Status</label>
            <b-select
              v-model="filter.status"
              :options="filterStatuses"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add Supplier
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index + 1) }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active === 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditForm(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-supplier-form"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      @ok="onConfirmAction"
      @show="onModalShow"
    >
      <ValidationObserver
        ref="form"
      >
        <form
          role="form"
          novalidate
        >
          <ValidationProvider
            #default="{ errors }"
            name="supplier type"
            vid="supplier_type"
            rules="required"
          >
            <b-form-group>
              <label for="supplier_type">Supplier Type</label>
              <b-form-select
                id="supplier_type"
                v-model="supplier.supplier_type"
                :options="supplier_types"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="isBusy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please select supplier type --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="trade name"
            vid="trade_name"
            rules="required|max:200"
          >
            <b-form-group>
              <label for="trade_name">Trade Name</label>
              <b-input
                id="trade_name"
                v-model="supplier.trade_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter trade name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="company name"
            vid="company_name"
            rules="max:200"
          >
            <b-form-group>
              <label for="company_name">Company Name</label>
              <b-input
                id="company_name"
                v-model="supplier.company_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter company name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="proprietor first name"
            vid="proprietor_first_name"
            rules="max:50"
          >
            <b-form-group>
              <label for="proprietor_first_name">Proprietor First Name</label>
              <b-input
                id="proprietor_first_name"
                v-model="supplier.proprietor_first_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter proprietor first name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="proprietor middle name"
            vid="proprietor_middle_name"
            rules="max:50"
          >
            <b-form-group>
              <label for="proprietor_middle_name">Proprietor Middle Name</label>
              <b-input
                id="proprietor_middle_name"
                v-model="supplier.proprietor_middle_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter proprietor middle name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="proprietor last name"
            vid="proprietor_last_name"
            rules="max:50"
          >
            <b-form-group>
              <label for="proprietor_last_name">Proprietor Last Name</label>
              <b-input
                id="proprietor_last_name"
                v-model="supplier.proprietor_last_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter proprietor last name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="tin"
            vid="tin"
            rules="required|min:16|max:16"
          >
            <b-form-group>
              <label for="tin">Tin</label>
              <b-input
                id="tin"
                v-model="supplier.tin"
                v-mask="'###-###-###-####'"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter  tin"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="address"
            vid="address"
            rules="required|max:500"
          >
            <b-form-group>
              <label for="address">Address</label>
              <b-form-textarea
                id="address"
                v-model="supplier.address"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter address"
                autocomplete="off"
                rows="6"
                max-rows="6"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="editMode"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="supplier.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="isBusy"
            >
              Is Active?
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="isBusy"
          @click="ok()"
        >
          {{ editMode ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="isBusy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { AxiosError, TaxAccountantSupplierService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'TaxAccountantSuppliers',

  middleware: ['auth', 'tax-accountant'],

  metaInfo () {
    return {
      title: 'Maintenance - Suppliers'
    }
  },

  mixins: [formatter],

  data () {
    return {
      editMode: false,
      isBusy: false,
      supplier_types: [
        { text: 'Sole Proprietorship', value: 'Sole Proprietorship' },
        { text: 'Corporation', value: 'Corporation' }
      ],
      supplier: {
        id: 0,
        active: 0,
        supplier_type: null,
        trade_name: '',
        company_name: '',
        proprietor_first_name: '',
        proprietor_middle_name: '',
        proprietor_last_name: '',
        tin: '',
        address: ''
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'supplier_type' },
          { key: 'trade_name', sortable: true },
          { key: 'company_name', sortable: true },
          { key: 'tin', label: 'tin' },
          { key: 'active', label: 'IS ACTIVE?' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      },
      filterStatuses: [
        { text: 'All', value: 'all' },
        { text: 'Active', value: '1' },
        { text: 'Inactive', value: '0' }
      ],
      filter: {
        status: 'all'
      }
    }
  },

  computed: {
    modalTitle () {
      return this.editMode ? 'Edit Supplier' : 'Add Supplier'
    }
  },

  watch: {
    'filter.status' () {
      this.$refs.table.refresh()
    }
  },

  mounted () {
    core.index()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await TaxAccountantSupplierService.get(`page=${ctx.currentPage}&per_page=${ctx.perPage}&sort=${ctx.sortBy}&sort_desc=${ctx.sortDesc}&filter_text=${ctx.filter}&filter_status=${this.filter.status}`)
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    onShowAddForm () {
      this.editMode = false
      this.$bvModal.show('modal-supplier-form')
    },

    onModalShow () {
      if (!this.editMode) {
        this.supplier.id = 0
        this.supplier.active = 1
        this.supplier.supplier_type = null
        this.supplier.trade_name = ''
        this.supplier.company_name = ''
        this.supplier.proprietor_first_name = ''
        this.supplier.proprietor_middle_name = ''
        this.supplier.proprietor_last_name = ''
        this.supplier.tin = ''
        this.supplier.address = ''
      }
    },

    onShowEditForm (item) {
      this.editMode = true
      this.supplier.id = item.id
      this.supplier.active = item.active
      this.supplier.supplier_type = item.supplier_type
      this.supplier.trade_name = item.trade_name
      this.supplier.company_name = item.company_name
      this.supplier.proprietor_first_name = item.proprietor_first_name
      this.supplier.proprietor_middle_name = item.proprietor_middle_name
      this.supplier.proprietor_last_name = item.proprietor_last_name
      this.supplier.tin = item.tin
      this.supplier.address = item.address
      this.$bvModal.show('modal-supplier-form')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          let title = 'Do you really want to create supplier?'

          if (this.editMode) {
            title = 'Do you really want to save changes?'
          }

          this.$swal.fire({
            icon: 'question',
            title: title,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              if (!this.editMode) {
                return this.onFormPostSubmit()
              } else {
                return this.onFormPutSubmit()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oppss! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger'
          })
        }
      })
    },

    async onFormPostSubmit () {
      return new Promise((resolve, reject) => {
        this.isBusy = true
        TaxAccountantSupplierService.post(this.supplier).then(response => {
          this.isBusy = false
          this.$bvModal.hide('modal-supplier-form')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: response.data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.table.refresh()
          })
        }).catch(error => {
          this.isBusy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    },

    async onFormPutSubmit () {
      return new Promise((resolve, reject) => {
        this.isBusy = true
        TaxAccountantSupplierService.put(this.supplier).then(response => {
          this.isBusy = false
          this.$bvModal.hide('modal-supplier-form')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: response.data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.table.refresh()
          })
        }).catch(error => {
          this.isBusy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    }
  }
}
</script>
